import ContactPerson from './ContactPerson'

export default ContactPerson
